import { createStore } from "vuex";
import axios from "axios";

var preFixApi = "https://fulfilmentmanagementapi.magazinecloner.com/"; // = "http://localhost:5000/"); //

export default createStore({
  state: {
    orderResponse: null,
    orderFound: null
  },
  mutations: {
    SET_ORDER(state, response) {
      state.orderResponse = response;
    },
    SET_ORDER_FOUND(state, response) {
      state.orderFound = response;
    }
  },
  actions: {
    getOrder({ state, commit }, transactionRef) {
      if (!state.orderResponse) {
        axios
          .get(preFixApi + "order-tracker/" + transactionRef)
          .then(response => {
            commit("SET_ORDER", response.data);
            commit("SET_ORDER_FOUND", true);
          })
          .catch(function(error) {
            commit("SET_ORDER_FOUND", false);
          });
      }
    },
    findOrder({ state, commit }, { jmag_order_id, billing_lastname, recapatcha }) {
      commit("SET_ORDER", null);
      return new Promise((resolve, reject) => {
        axios
          .get(
            preFixApi +
              "order-tracker/search?jmagOrderId=" +
              jmag_order_id +
              "&billingLastName=" +
              billing_lastname,
            {
              headers: {
                "google-recaptcha": recapatcha
              }
            }
          )
          .then(response => {
            commit("SET_ORDER", response.data);
            commit("SET_ORDER_FOUND", true);
            resolve(response);
          })
          .catch(function(error) {
            commit("SET_ORDER_FOUND", false);
            reject(error);
          });
      });
    }
  },
  modules: {}
});
